import { css, LitElement, html } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';

var css_248z = css`.checkbox-wrapper {
  display: flex;
  margin-bottom: 8px;
  align-items: center;
  /*
  BASE STYLING
  */
  /*
  STATE STYLING
  */
}
.checkbox-wrapper ::slotted(input) {
  -webkit-appearance: initial;
  appearance: initial;
  width: 16px;
  height: 16px;
  border: 1px solid #b3b3b3;
  border-radius: 2px;
  position: relative;
  margin: 0 12px 0 0;
}
.checkbox-wrapper label,
.checkbox-wrapper ::slotted(label) {
  font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #3c5e5e;
}
.checkbox-wrapper label,
.checkbox-wrapper ::slotted(label) {
  display: flex;
  align-items: center;
  width: calc(100% - (16px + 12px));
  margin-top: -1px;
  font-weight: 400;
  color: #222;
  column-gap: 8px;
}
.checkbox-wrapper ::slotted(input:checked), .checkbox-wrapper.indeterminate ::slotted(input) {
  background: #00857a;
  border: 1px solid transparent;
}
.checkbox-wrapper ::slotted(input:checked)::before {
  content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 8'%3e%3cpath fill='%23FFF' d='M4.77466 6.54768L9.47144 1.81286C9.73172 1.55027 9.73172 1.12526 9.47144 0.862673C9.2105 0.60144 8.78814 0.60144 8.52854 0.862673L3.83176 5.59817L1.47243 3.2197C1.21081 2.95846 0.789128 2.95846 0.529527 3.2197C0.267908 3.48161 0.267908 3.90662 0.529527 4.16988L2.88953 6.54768L3.36031 7.02209C3.62126 7.28468 4.04294 7.28468 4.30321 7.02209L4.77466 6.54768Z'/%3e%3c/svg%3e");
  position: absolute;
  width: 12px;
  height: 12px;
  left: 2px;
  top: 1px;
}
.checkbox-wrapper ::slotted(input:checked:not(:disabled))::before {
  left: 1px;
  top: 0;
}
.checkbox-wrapper ::slotted(input::-ms-check) {
  color: #fff;
  fill: #fff;
  background-color: transparent;
}
.checkbox-wrapper ::slotted(input:checked:hover)::before {
  left: 2px;
  top: 1px;
}
.checkbox-wrapper ::slotted(input:hover) {
  background-color: #d8f0ef;
  border: 1px solid #86d1cd;
}
.checkbox-wrapper ::slotted(input:checked:hover), .checkbox-wrapper.indeterminate ::slotted(input:hover) {
  background-color: #00716b;
  border: none;
}
.checkbox-wrapper ::slotted(input:active) {
  background-color: #ade0df;
  border: 1px solid #37aba1;
}
.checkbox-wrapper ::slotted(input:focus) {
  border: 1px solid #00716b;
}
.checkbox-wrapper ::slotted(input:checked:focus) {
  background-color: #00716b;
}
.checkbox-wrapper ::slotted(input:disabled) {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
}
.checkbox-wrapper ::slotted(input:checked:disabled) {
  background-color: #b3b3b3;
  border: none;
}
.checkbox-wrapper.indeterminate ::slotted(input:hover)::before {
  left: 2px;
  top: 1px;
}
.checkbox-wrapper.indeterminate ::slotted(input)::before {
  content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3e%3cpath fill='%23FFF' d='M1.33335 1.66659C0.964687 1.66659 0.666687 1.36792 0.666687 0.999919C0.666687 0.631919 0.964687 0.333252 1.33335 0.333252H10.6667C11.0354 0.333252 11.3334 0.631919 11.3334 0.999919C11.3334 1.36792 11.0354 1.66659 10.6667 1.66659H1.33335Z'/%3e%3c/svg%3e") !important;
  position: absolute;
  width: 12px;
  left: 1px;
  top: 0;
}
.checkbox-wrapper.disabled ::slotted(label) {
  color: #222 !important;
  filter: grayscale(1);
  opacity: 0.57;
}
.checkbox-wrapper.invalid ::slotted(input) {
  border: 1px solid #db402c;
}
.checkbox-wrapper.invalid ::slotted(input:checked) {
  background-color: #db402c;
}
.checkbox-wrapper.invalid ::slotted(label) {
  color: #db402c;
}
.checkbox-wrapper.invalid.indeterminate ::slotted(input) {
  background-color: #db402c;
}

/* enriched checkbox */
.checkbox-wrapper[enriched] {
  background-color: #edf7f7;
  border: 1px solid #edf7f7;
  padding: 16px;
  width: inherit;
  margin-bottom: 4px;
  border-radius: 2px;
}
.checkbox-wrapper[enriched]:hover {
  background-color: #d8f0ef;
  border: 1px solid #86d1cd;
}
.checkbox-wrapper[enriched].checked {
  border: 2px solid #00716b;
  background-color: #fff;
  padding: 15px;
}
.checkbox-wrapper[enriched].checked:hover {
  background-color: #d8f0ef;
}
.checkbox-wrapper[enriched]:active, .checkbox-wrapper[enriched].checked:active {
  background-color: #ade0df;
}
.checkbox-wrapper[enriched].disabled, .checkbox-wrapper[enriched].disabled:hover, .checkbox-wrapper[enriched].disabled:active {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  padding: 16px;
}
.checkbox-wrapper[enriched][centered] {
  align-items: flex-start;
  box-sizing: border-box;
  height: 100%;
}
.checkbox-wrapper[enriched][centered] input,
.checkbox-wrapper[enriched][centered] ::slotted(input) {
  flex-shrink: 0;
}
.checkbox-wrapper[enriched][centered] label,
.checkbox-wrapper[enriched][centered] ::slotted(label) {
  flex-direction: column;
  text-align: center;
  margin-right: 24px;
}`;

/* eslint-disable lit-a11y/click-events-have-key-events */

class AabCheckbox extends LitElement {
  static get properties() {
    return {
      invalid: { type: Boolean },
      indeterminate: { type: Boolean },
      disabled: { type: Boolean },
      checked: { type: Boolean },
      enriched: { type: Boolean },
      centered: { type: Boolean },
    };
  }

  constructor() {
    super();
    // Initialize LitElement properties here
    this.checked = false; // used to pass checked state from input to this element
    this.enriched = false; // this activates the enriched checkbox
    this.centered = false; // this activates the horizontal centered version of the enriched checkbox
  }
  static get styles() {
    return [css_248z];
  }

  /*
   * Add listener for change event from <input> in slot
   */
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(
      'change',
      this.handleCheckBoxStateChangedEvent,
    );
  }

  /*
   * Remove listener for change event
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('change', this.handleCheckBoxStateChangedEvent);
  }

  /**
   * This listens to the change in the checkbox 'checked' state, and adds/removes then the
   * appropriate class on the wrapper
   * @param event
   */
  handleCheckBoxStateChangedEvent(event) {
    this.checked = event.target.checked;
  }

  /**
   * This extra click listener is needed so when an end-user clicks on the padding/whitespace the checkbox also flips state (checked).
   * @param event
   * @returns {Promise<void>}
   */
  async handleClick(event) {
    // check if the click-event is coming from the div.checkbox-wrapper
    // (and ignore if click is taken care off by the <label> or the <input> element)
    if (event.target.classList.contains('checkbox-wrapper')) {
      // targeting the label(!) element instead of the input-element due to wonkiness of the behaviour in that case
      const labelElement = this.shadowRoot.querySelector('slot[name^=label]').assignedElements({ selector: 'label' })[0];
      // stop propagation so we have no merry-go-round
      event.stopPropagation();
      // the magic(tm)
      labelElement.click();
      // need to wait for propagation tru web-component, otherwise it looks like snails are running the show
      await this.requestUpdate();
    }
  }

  render() {
    const dynamicClasses = {
      'checkbox-wrapper': true,
      checked: this.checked,
      invalid: this.invalid,
      indeterminate: this.indeterminate,
      disabled: this.disabled,
    };
    return html`
      <div class="${classMap(dynamicClasses)}"
           ?enriched=${this.enriched}
           ?centered=${this.centered}
           @click="${this.handleClick}">
        <slot name="input-slot"></slot>
        <slot name="label-slot"></slot>
      </div>
    `;
  }
}

export { AabCheckbox as default };
